module.exports = __webpack_public_path__ + "img/icon-home-yellow.c7825437.svg";